import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import * as actionTypes from '../types/applicationDetailTypes';

export const setApplicationDetailsRedux = (payload: any): Action<void> => updateAction(actionTypes.SET_APPLICATION_DETAIL, payload);
export const clearApplicationDetails = (): Action<void> => updateAction(actionTypes.CLEAR_APPLICATION_DETAIL);
export const updateIpConfig = (payload: any): Action<any> => updateAction(actionTypes.UPDATE_IP_CONFIG, payload);
export const updateIpConfigPreAuthViewConfig = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_IP_PRE_AUTH_VIEW_CONFIG, payload);
export const updateGrievanceConfig = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_GRIEVANCE_CONFIG, payload);
export const updateIpConfigClaimViewConfig = (payload: any): Action<any> => updateAction(actionTypes.UPDATE_IP_CLAIM_VIEW_CONFIG, payload);
export const updateReconciliationIpConfig = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_RECONCILIATION_IP_CONFIG, payload);
export const updateClaimsDisplayConfig = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_CLAIMS_DISPLAY_CONFIG, payload);
export const setHipID = (payload: any): Action<void> => updateAction(actionTypes.SET_HIP_ID, payload);
export const updateReportingConfig = (payload: any): Action<any> => {
  return updateAction(actionTypes.UPDATE_REPORTING_CONFIG, payload);
};
export const updateTatReportingConfig = (payload: any): Action<any> => {
  return updateAction(actionTypes.UPDATE_TAT_REPORTING_CONFIG, payload);
};
